import { createApp } from 'vue';
import './style.css';
import App from './App.vue';

// 1. 先创建/导入核心实例（路由、Pinia）
import router from './router'; // 导入路由实例
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';

import { createPinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate';
const pinia = createPinia();
pinia.use(createPersistedState());

// 2. 创建App实例，并按顺序挂载核心插件（先Pinia，再路由）
const app = createApp(App);
app.use(ElementPlus);
app.use(pinia); // 先挂载Pinia（守卫要用store，必须在前）
app.use(router); // 再挂载路由，让router实例完全初始化

// 3. 最后加载权限守卫（此时router和pinia都已挂载完成）
// import './router/permission'; // 关键：导入permission.js，触发守卫挂载

// 4. 挂载App
app.mount('#app');